<template>
    <div class="col-md-7">
        <h2>Delivery Information</h2>

        <div class="form-group">
            <input type="text" class="form-control" placeholder="" v-model="localShipping.first_name" aria-describedby="first name" name="first_name"
                   :class="{'is-invalid': hasError('shipping.first_name')}">
            <small class="form-text text-muted">First Name*</small>
            <div class="invalid-feedback">
                The first name field is required.
            </div>
        </div>

        <div class="form-group">
            <input type="email" class="form-control" placeholder="" v-model="localShipping.last_name" aria-describedby="last name" name="last_name"
                   :class="{'is-invalid': hasError('shipping.last_name')}">
            <small class="form-text text-muted">Last Name*</small>
            <div class="invalid-feedback">
                The last name field is required.
            </div>
        </div>

        <div class="form-group">

            <input type="email" class="form-control" placeholder="" v-model="localShipping.email_address" aria-describedby="email address" name="email_address"
                   :class="{'is-invalid': hasError('shipping.email_address')}" @blur="emailChanged">
            <small class="form-text text-muted">Email Address*</small>
            <div class="invalid-feedback">
                The email address field is required and must be a valid email.
            </div>

        </div>

        <div class="form-group">

            <input type="text" class="form-control" placeholder="" v-model="localShipping.phone_number" aria-describedby="phone_number" name="phone_number"
                   :class="{'is-invalid': hasError('shipping.phone_number')}">
            <small class="form-text text-muted">Phone Number*</small>
            <div class="invalid-feedback">
                The phone number field is required.
            </div>

        </div>

        <div class="form-group">

            <input type="text" class="form-control" placeholder="" v-model="localShipping.street" aria-describedby="address" name="address"
                   :class="{'is-invalid': hasError('shipping.street')}">
            <small class="form-text text-muted">Address*</small>
            <div class="invalid-feedback">
                The address field is required.
            </div>

        </div>

        <div class="form-group">
            <input type="city" class="form-control" aria-describedby="city" placeholder="" v-model="localShipping.city" name="city"
                   :class="{'is-invalid': hasError('shipping.city')}">
            <small class="form-text text-muted">City*</small>
            <div class="invalid-feedback">
                The city field is required.
            </div>
        </div>

        <div class="form-group">
            <select class="form-control" v-model="localShipping.state" aria-describedby="state" name="state"
                    :class="{'is-invalid': hasError('shipping.state')}">
                <option v-for="state in states">{{ state }}</option>
            </select>
            <small class="form-text text-muted">State*</small>
            <div class="invalid-feedback">
                The state field is required.
            </div>
        </div>

        <div class="form-group">
            <input type="city" class="form-control" aria-describedby="zipcode" placeholder="" v-model="localShipping.zipcode" name="zipcode"
                   :class="{'is-invalid': hasError('shipping.zipcode')}">
            <small class="form-text text-muted">Zipcode*</small>
            <div class="invalid-feedback">
                The zipcode field is required.
            </div>
        </div>

        <div class="form-group">
            <select class="form-control" v-model="localShipping.preferred_contact_method" aria-describedby="preferred contact method" name="preferred_contact_method"
                    :class="{'is-invalid': hasError('shipping.preferred_contact_method')}">
                <option value="phone">Phone Call</option>
                <option value="email">Email</option>
                <option value="text">Text Message</option>
            </select>
            <small class="form-text text-muted">Preferred Contact Method</small>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['states', 'shipping', 'errors'],

        data() {
            return {
                localShipping: {},
            }
        },

        created() {
            this.localShipping = this.shipping;
        },


        watch: {
            localShipping() {
                this.syncToParent()
            },
        },

        methods: {
            syncToParent() {
                this.$emit('data-changed', {shipping: this.localShipping});
            },

            emailChanged() {
                this.$emit('email-changed', this.localShipping.email_address);
            },

            hasError(field) {
                if (this.errors[field]) {
                    return true;
                }

                return false;
            }
        }
    }
</script>
